export enum TransactionType{
  BIZCOMP = 'BC',
  DEALSTATS = 'DS',
  RMA = 'RMA'
}
